import { ref } from "vue";
import { fabric } from "fabric";

import { addUserObject, getObjectProperty } from "@/canvas-api/Canvas";

export const currentText = ref("Enter Text Here");
export const currentFont = ref("Open Sans");
export const currentFontSize = ref(24);

export const pxToPts = (px: number): number => {
  return (px * 72) / 96; // 72 is Photoshop DPI 96 is Broswer DPI
};

export const ptsToPx = (pts: number): number => {
  return (pts * 96) / 72;
};

export const iText = ref<fabric.IText>();
export const makeNewText = (defaultText: string, defaultSize: number, fontFamily: string): void => {
  const newIText: fabric.IText = new fabric.IText(defaultText, {
    id: 0,
    fontFamily: fontFamily,
    fontSize: defaultSize,
    fontWeight: "normal",
    fontStyle: "normal",
    stroke: "#0001ba",
    strokeWidth: 0,
    opacity: 1,
    underline: false,
    fill: "#000",
    textAlign: "left",
    originX: "center",
    originY: "center",
    name: "iText",
  } as fabric.ITextOptions) as fabric.IText;

  newIText.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false });

  addUserObject(newIText);
};

export const updateText = (prop: string, value: string | boolean | number) => {
  getObjectProperty({ name: prop, value: value });
};
